(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icon-box"] && !Shopify.designMode) return;
  try {
    

  const slider = document.querySelector(".icon_coru_img");
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener("mousedown", e => {
  isDown = true;
  slider.classList.add("active");
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener("mouseleave", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mouseup", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mousemove", e => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3;
  slider.scrollLeft = scrollLeft - walk;
});
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll_card"] && !Shopify.designMode) return;
  try {
    

  function clickLeft() {
			let container = document.querySelector("#flex-container");
			container.scrollTo({
				left:container.scrollLeft - 200,
				top: 0,
				behavior: "smooth"
			});
		}

		function clickRight() {
			let container = document.querySelector("#flex-container");
			container.scrollTo({
				left:container.scrollLeft + 200,
				top: 0,
				behavior: "smooth"
			});
		}

  const slider = document.querySelector(".outer");
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener("mousedown", e => {
  isDown = true;
  slider.classList.add("active");
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener("mouseleave", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mouseup", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mousemove", e => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3;
  slider.scrollLeft = scrollLeft - walk;
});
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-tab"] && !Shopify.designMode) return;
  try {
    
    const showAllTab = document.querySelector('.show-all');
    const coimbatoreTab = document.querySelector('.coimbatore');
    const bangloreTab =  document.querySelector('.banglore');
    const chennaiTab = document.querySelector('.chennai');
    const maduraiTab = document.querySelector('.madurai');
    const salemTab = document.querySelector('.salem');
    const trichyTab = document.querySelector('.trichy');
    const pondicherryTab = document.querySelector('.pondicherry');
    const mysoreTab = document.querySelector('.mysore');
  const kochiTab = document.querySelector('.kochi');
  
const allFilteredDivs = document.querySelectorAll('.store_filtered-div');

  
// Turns node list into an array
const allFilteredDivsArray = Array.from(allFilteredDivs)
  
const tabs = document.querySelectorAll('.store_btn');
  


function addActive() {
    tabs.forEach(tab => {
        tab.classList.remove('active_tab');
    });
    event.target.classList.add('active_tab');
}
  
showAllTab.addEventListener('click', showAll)
function showAll() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    div.classList.add('show')
  });
  addActive();
}

coimbatoreTab.addEventListener('click', showCoimbatore)
function showCoimbatore() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')

    if (!div.dataset.coimbatore) {
      div.classList.add('remove')
    }
  });
  addActive();
}

bangloreTab.addEventListener('click', showBanglore)
function showBanglore() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')

    if (!div.dataset.banglore) {
      div.classList.add('remove')
    }
  });
  addActive();
}

chennaiTab.addEventListener('click', showChennai)
function showChennai() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    
    if (!div.dataset.chennai) {
      div.classList.add('remove')
    }
  });
  addActive();
}

  maduraiTab.addEventListener('click', showMadurai)
function showMadurai() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    
    if (!div.dataset.madurai) {
      div.classList.add('remove')
    }
  });
  addActive();
}

  salemTab.addEventListener('click', showSalem)
function showSalem() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    
    if (!div.dataset.salem) {
      div.classList.add('remove')
    }
  });
  addActive();
}

  pondicherryTab.addEventListener('click', showPondicherry)
function showPondicherry() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    
    if (!div.dataset.pondicherry) {
      div.classList.add('remove')
    }
  });
  addActive();
}

  mysoreTab.addEventListener('click', showMysore)
function showMysore() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    
    if (!div.dataset.mysore) {
      div.classList.add('remove')
    }
  });
  addActive();
}

  trichyTab.addEventListener('click', showTrichy)
function showTrichy() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    
    if (!div.dataset.trichy) {
      div.classList.add('remove')
    }
  });
  addActive();
}
  kochiTab.addEventListener('click', showKochi)
function showKochi() {
  allFilteredDivsArray.forEach(div => {
    div.classList.remove('remove')
    
    if (!div.dataset.kochi) {
      div.classList.add('remove')
    }
  });
  addActive();
}

  const slider = document.querySelector(".store_btn_main_box");
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener("mousedown", e => {
  isDown = true;
  slider.classList.add("active");
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener("mouseleave", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mouseup", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mousemove", e => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3;
  slider.scrollLeft = scrollLeft - walk;
});
  
  } catch(e) { console.error(e); }
})();
})();
